"use client"
import { create } from "zustand"

interface StateVoyagesData {
  voyages: any[],
  voyage: any,
  voyagesByState: any[],
  error: string | null,
  loading: boolean,

  fetchVoyages: () => Promise<void>,
  fetchVoyage: (slug: string) => Promise<void>,
  fetchVoyagesByState: (slug: string) => Promise<void>,
  fetchVoyagesFull: (slug: string) => Promise<void>,
}

export const useVoyagesData = create<StateVoyagesData>((set) => ({
  voyages: [],
  voyage: null,
  voyagesByState: [],
  error: null,
  loading: false,

  //------------------------------------
  // 📌 Fetch all voyages
  //------------------------------------
  fetchVoyages: async () => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}voyages`)
      if (!res.ok) throw new Error("Failed to fetch voyages")

      const data = await res.json()
      set({ voyages: data.voyages })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },

  //------------------------------------
  // 📌 Fetch ONE voyage
  //------------------------------------
  fetchVoyage: async (slug: string) => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}allvoyages/${slug}`)
      if (!res.ok) throw new Error("Failed to fetch voyage")

      const data = await res.json()
      set({ voyage: data.voyage })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },

  //------------------------------------
  // 📌 Fetch Voyages by State
  //------------------------------------
  fetchVoyagesByState: async (slug: string) => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}voyagesbystate/${slug}`
      )
      if (!res.ok) throw new Error("Failed to fetch voyages by state")

      const data = await res.json()
      set({ voyagesByState: data.voyages.data })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },

  //------------------------------------
  // ⭐ Fetch VOYAGE + VOYAGES BY STATE (FULL)
  //------------------------------------
  fetchVoyagesFull: async (slug: string) => {
    set({ loading: true, error: null })

    try {
      const [voyageRes, voyagesStateRes] = await Promise.all([
        fetch(`${process.env.NEXT_PUBLIC_API_URL}allvoyages/${slug}`),
        fetch(`${process.env.NEXT_PUBLIC_API_URL}voyagesbystate/${slug}`),
      ])

      if (!voyageRes.ok) throw new Error("Failed to fetch voyage")
      if (!voyagesStateRes.ok) throw new Error("Failed to fetch voyages by state")

      const voyageData = await voyageRes.json()
      const voyagesStateData = await voyagesStateRes.json()

      set({
        voyage: voyageData.voyage,
        voyagesByState: voyagesStateData.voyages,
      })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },
}))
